<template>
  <v-row no-gutters>
    <v-col cols="12" class="pr-10">
      <card-title-row :straightTitle="additionalModuleName" class="pt-5 pb-2" :has-buttons="false" />
      <sidebar-form
        v-model="params"
        :is-valid.sync="isValid"
        ref="form"
        :inputs="paramsInputs"
        :is-editing-on="!isStickyButtonsLoading"
      >
        <template #voivodeship="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="params[data.name]" @change="getDistricts" />
        </template>
        <template #district="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="params[data.name]" @change="getCommunities" />
        </template>
        <template #community="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="params[data.name]" @change="getPrecincts" />
        </template>
        <template #precinct="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="params[data.name]" @change="updateParcelTerrit" />
        </template>
        <template #parcelId="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="params[data.name]" @input="updateParcelTerrit" />
        </template>
        <template #precinctNotKnown="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="params[data.name]" @input="updateParcelTerrit" />
        </template>
        <template #parcelTerrit="data">
          <data-input v-bind="{ ...data, dense: true }" v-model="parcelTerrit" @change="changeParcelTerrit" />
        </template>
      </sidebar-form>
      <v-row no-gutters class="pt-5">
        <v-col cols="12" class="pl-10">
          <v-list class="py-0 results-list" dense>
            <v-list-item
              v-for="(parcel, idx) in computedResultList"
              :key="idx"
              class="result-element hover-list-element px-2"
            >
              <v-list-item-content>
                <v-row no-gutters class="text-body-2">
                  <v-col cols="auto" class="pr-1 result-text-parcel">{{ `${parcel.parcelId}` }}</v-col>
                  <v-col cols="auto" class="result-text-precinct">{{
                    `(obręb: ${parcel.precinct}${parcel.mapSheet ? `, arkusz: ${parcel.mapSheet}` : ''})`
                  }}</v-col>
                </v-row>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon size="20" @click="addParcel(parcel.wktGeom)">
                  mdi-magnify
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { call, get, sync } from 'vuex-pathify';
import CardTitleRow from '@/components/CardTitleRow';
import DataInput from '@/components/DataInput';
import SidebarForm from '@/components/SidebarForm';
export default {
  name: 'UldkInfo',
  components: {
    CardTitleRow,
    DataInput,
    SidebarForm,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules@PARCELS.verbose_name'),
    computedResultList() {
      return this.resultList.map(result => {
        const parcelTerrit = result[1];
        const computedResult = { parcelId: result[0], parcelTerrit, wktGeom: result[2] };
        const dotsIndexes = [];
        for (let i = 0; i < parcelTerrit.length; i++) {
          if (parcelTerrit[i] === '.') {
            dotsIndexes.push(i);
          }
        }
        const numberOfDots = dotsIndexes.length;
        computedResult.precinct = parcelTerrit.substr(dotsIndexes[0] + 1, 4);
        if (numberOfDots > 2) {
          computedResult.mapSheet = parcelTerrit.substring(dotsIndexes[1] + 1, dotsIndexes[2]);
        }
        return computedResult;
      });
    },
    paramsInputs() {
      const inputs = [
        {
          name: 'voivodeship',
          translationPath: 'sidebar.uldk.voivodeship',
          dataType: { name: 'select' },
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['voivodeship']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}` };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: [this.rules.required],
          cols: '7',
          nameCols: '5',
        },
        {
          name: 'district',
          translationPath: 'sidebar.uldk.district',
          dataType: { name: 'select' },
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['district']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}` };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: [this.rules.required],
          readonly: !this.params['voivodeship'],
          cols: '7',
          nameCols: '5',
        },
        {
          name: 'community',
          translationPath: 'sidebar.uldk.community',
          dataType: { name: 'select' },
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['community']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}`, value: item.territId.split('_')[0] };
          }),
          itemText: 'text',
          returnObject: true,
          rules: [this.rules.required],
          readonly: !this.params['district'],
          cols: '7',
          nameCols: '5',
        },
        {
          name: 'precinct',
          translationPath: 'sidebar.uldk.precinct',
          dataType: { name: 'select' },
          items: this.$_sortObjectsByAttribute(
            this.$_objectToArray(this.admnistrativeParamsItems['precinct']),
            'name'
          ).map(item => {
            return { ...item, text: `${item.name} | ${item.territId}` };
          }),
          itemText: 'text',
          itemValue: 'territId',
          returnObject: true,
          rules: this.params.precinctNotKnown ? [] : [this.rules.required],
          disabled: this.params.precinctNotKnown,
          readonly: !this.params['community'],
          cols: '7',
          nameCols: '5',
        },
        {
          name: 'precinctNotKnown',
          label: this.$i18n.t('sidebar.uldk.precinctNotKnown'),
          dataType: { name: 'checkbox' },
          hasNameColumn: false,
          cols: '12',
          messages: this.$i18n.t('sidebar.uldk.precinctNotKnownSubtitle'),
        },
        {
          name: 'parcelId',
          translationPath: 'sidebar.uldk.parcelId',
          dataType: { name: 'text' },
          rules: [this.rules.required],
          cols: '7',
          nameCols: '5',
          hasSubtitle: true,
          hasSmallSubtitle: true,
          subtitlePath: 'sidebar.uldk.parcelIdSubtitle',
        },
        {
          name: 'parcelTerrit',
          translationPath: 'sidebar.uldk.parcelTerrit',
          dataType: { name: 'text' },
          rules: [this.rules.required, this.rules.parcelTerrit],
          cols: '7',
          nameCols: '5',
          hasSubtitle: true,
          hasSmallSubtitle: true,
          subtitlePath: 'sidebar.uldk.parcelTerritSubtitle',
        },
      ];
      return inputs;
    },
    rules() {
      return {
        required: v => !!v || this.$i18n.t('rules.required'),
        parcelTerrit: () => {
          return (
            this.isParcelTerritValid.valid || this.$i18n.t(`sidebar.uldk.${this.isParcelTerritValid.error}BadTerrit`)
          );
        },
      };
    },
    isStickyButtonsLoading: sync('sidebar/isStickyButtonsLoading'),
    isStickyButtonsValid: sync('sidebar/isStickyButtonsValid'),
    isStickyButtonsVisible: sync('sidebar/isStickyButtonsVisible'),
    stickyButtons: sync('sidebar/stickyButtons'),
  },
  data: () => ({
    admnistrativeParamsItems: {
      voivodeship: [],
      district: [],
      community: [],
      precinct: [],
    },
    isParcelTerritValid: { valid: true },
    isValid: false,
    params: {},
    parcelTerrit: '',
    resultList: [],
  }),
  methods: {
    getUldkCommunities: call('search/getUldkCommunities'),
    getUldkDistricts: call('search/getUldkDistricts'),
    getUldkPrecincts: call('search/getUldkPrecincts'),
    getUldkVoivodeships: call('search/getUldkVoivodeships'),
    searchUldkParcel: call('search/searchUldkParcel'),
    addParcel(parcel) {
      this.$root.$emit('addUldkParcelToMap', parcel);
    },
    clear() {
      this.$router.push({ name: 'map' });
    },
    async getCommunities(nV, updateParcelTerrit = true, resetValidation = true) {
      this.params.community = '';
      this.params = { ...this.params, precinct: '' };
      if (updateParcelTerrit) {
        this.updateParcelTerrit();
      }
      const r = await this.getUldkCommunities(nV.territId);
      this.admnistrativeParamsItems.community = r;
      if (resetValidation) {
        this.$refs?.form.$refs?.form.resetValidation();
      }
    },
    async getDistricts(nV, updateParcelTerrit = true, resetValidation = true) {
      this.params.district = '';
      this.params.community = '';
      this.params = { ...this.params, precinct: '' };
      if (updateParcelTerrit) {
        this.updateParcelTerrit();
      }
      const r = await this.getUldkDistricts(nV.territId);
      this.admnistrativeParamsItems.district = r;
      if (resetValidation) {
        this.$refs?.form.$refs?.form.resetValidation();
      }
    },
    async getPrecincts(nV, updateParcelTerrit = true, resetValidation = true) {
      this.params.precinct = '';
      if (updateParcelTerrit) {
        this.updateParcelTerrit();
      }
      const r = await this.getUldkPrecincts(nV.territId);
      this.admnistrativeParamsItems.precinct = r;
      if (resetValidation) {
        this.$refs?.form.$refs?.form.resetValidation();
      }
    },
    async getVoivodeships() {
      const r = await this.getUldkVoivodeships();
      this.admnistrativeParamsItems.voivodeship = r;
      this.$refs?.form.$refs?.form.resetValidation();
    },
    async changeParcelTerrit(nV) {
      if (nV.length >= 2) {
        const voivodeshipTerrit = nV.substring(0, 2);
        const voivodeship = this.admnistrativeParamsItems.voivodeship[voivodeshipTerrit];
        if (!voivodeship) {
          this.isParcelTerritValid = { valid: false, error: 'voivodeship' };
          this.$refs?.form.$refs?.form.validate();
          return;
        }
        this.params.voivodeship = voivodeship;
        this.$refs?.form.$refs?.form.resetValidation();
        await this.getDistricts(voivodeship, false, false);
      }
      if (nV.length >= 4) {
        const districtTerrit = nV.substring(0, 4);
        const district = this.admnistrativeParamsItems.district[districtTerrit];
        if (!district) {
          this.isParcelTerritValid = { valid: false, error: 'district' };
          this.$refs?.form.$refs?.form.validate();
          return;
        }
        this.params.district = district;
        this.$refs?.form.$refs?.form.resetValidation();
        await this.getCommunities(district, false, false);
      }
      if (nV.length >= 8) {
        const communityTerrit = nV.substring(0, 8);
        const mappedCommunities = this.$_mapObjectKeys(
          this.admnistrativeParamsItems.community,
          key => key.split('_')[0]
        );
        const community = mappedCommunities[communityTerrit.split('_')[0]];
        if (!community) {
          this.isParcelTerritValid = { valid: false, error: 'community' };
          this.$refs?.form.$refs?.form.validate();
          return;
        }
        this.params.community = { ...community, value: community.territId.split('_')[0] };
        this.$refs?.form.$refs?.form.resetValidation();
        await this.getPrecincts(community, false, false);
      }
      if (nV.length >= 10 && nV.substring(8, 10) === '.?') {
        const precinctNotKnown = true;
        this.params = { ...this.params, precinctNotKnown };
        this.$refs?.form.$refs?.form.validate();
      } else if (nV.length >= 13) {
        const precinctTerrit = nV.substring(0, 13);
        const precinct = this.admnistrativeParamsItems.precinct[precinctTerrit];
        if (!precinct) {
          this.isParcelTerritValid = { valid: false, error: 'precinct' };
          this.$refs?.form.$refs?.form.validate();
          return;
        }
        const precinctNotKnown = false;
        this.params = { ...this.params, precinct, precinctNotKnown };
      }
      this.params.parcelId = '';
      if (nV.length >= 12 && nV.substring(8, 10) === '.?' && nV[10] === '.') {
        this.params.parcelId = nV.substr(11, nV.length);
      } else if (nV.length >= 15 && nV[13] === '.') {
        this.params.parcelId = nV.substr(14, nV.length);
      }
      this.isParcelTerritValid = { valid: true };
      this.$refs?.form.$refs?.form.validate();
    },
    async search() {
      this.resultList = [];
      this.isStickyButtonsLoading = true;
      if (this.params.precinctNotKnown) {
        let resultList = [];
        const index = this.parcelTerrit.indexOf('.?');
        for (const item of this.$_objectToArray(this.admnistrativeParamsItems.precinct)) {
          const territ = `${item.territId}${this.parcelTerrit.substring(index + 2)}`;
          const r = await this.searchUldkParcel({ territ });
          if (r.length > 0) {
            resultList = resultList.concat(r);
          }
        }
        if (resultList.length < 1) {
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('sidebar.uldk.noResults'),
          });
        } else {
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('sidebar.uldk.severalResultsFound'),
          });
          this.resultList = resultList;
        }
      } else {
        const r = await this.searchUldkParcel({ territ: this.parcelTerrit });
        if (r.length < 1) {
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('sidebar.uldk.noResults'),
          });
        } else if (r.length === 1) {
          this.addParcel(r[0][2]);
        } else {
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('sidebar.uldk.severalMapSheetsResults'),
          });
          this.resultList = r;
        }
      }
      this.isStickyButtonsLoading = false;
    },
    updateParcelTerrit() {
      let territ = '';
      if (this.params.precinct && !this.params.precinctNotKnown) {
        territ += this.params.precinct.territId || '';
        if (this.params.parcelId) {
          territ += `.${this.params.parcelId}`;
        }
      } else if (this.params.community) {
        territ += this.params.community.territId || '';
        if (this.params.precinctNotKnown) {
          territ += '.?';
          if (this.params.parcelId) {
            territ += `.${this.params.parcelId}`;
          }
        }
      } else if (this.params.district) {
        territ += this.params.district.territId || '';
      } else if (this.params.voivodeship) {
        territ += this.params.voivodeship.territId || '';
      }
      this.parcelTerrit = territ;
      this.isParcelTerritValid = { valid: true };
    },
    async init() {
      await this.getVoivodeships();
      const voivodeship = JSON.parse(localStorage.getItem('uldkVoivodeship') || '{}');
      if (localStorage.getItem('uldkVoivodeship')) {
        this.params = { ...this.params, voivodeship };
        await this.getDistricts(voivodeship, true, true, false);
        const district = JSON.parse(localStorage.getItem('uldkDistrict') || '{}');
        if (localStorage.getItem('uldkDistrict')) {
          this.params = { ...this.params, district };
          await this.getCommunities(district, true, true, false);
          const community = JSON.parse(localStorage.getItem('uldkCommunity') || '{}');
          if (localStorage.getItem('uldkCommunity')) {
            this.params = { ...this.params, community };
            await this.getPrecincts(community);
            if (localStorage.getItem('uldkPrecinct')) {
              const precinct = JSON.parse(localStorage.getItem('uldkPrecinct') || '{}');
              this.params = { ...this.params, precinct };
            }
          }
        }
      }
      this.$watch(
        vm => vm.params,
        nV => {
          Object.entries({
            community: 'uldkCommunity',
            voivodeship: 'uldkVoivodeship',
            district: 'uldkDistrict',
            precinct: 'uldkPrecinct',
          }).forEach(([key, storageKey]) => {
            const value =
              key === 'community'
                ? nV[key]
                  ? { ...nV[key], value: nV[key].territId.split('_')[0] }
                  : nV[key]
                : nV[key];
            localStorage.setItem(storageKey, JSON.stringify(value));
          });
        },
        {
          deep: true,
        }
      );
      this.$root.$off('uldkClear');
      this.$root.$off('uldkSearch');
      this.$root.$on('uldkClear', this.clear);
      this.$root.$on('uldkSearch', this.search);
      this.stickyButtons = [
        {
          action: 'uldkSearch',
          translationPath: 'sidebar.uldk.search',
        },
        {
          action: 'uldkClear',
          translationPath: 'button.cancel',
          cancel: true,
        },
      ];
      this.isStickyButtonsVisible = true;
      this.isStickyButtonsValid = false;
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    isValid(nV) {
      this.isStickyButtonsValid = nV;
    },
  },
  beforeDestroy() {
    this.$root.$emit('clearUldkParcel');
    this.isStickyButtonsVisible = false;
    this.stickyButtons = [];
    this.isStickyButtonsValid = false;
    this.isStickyButtonsLoading = false;
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-input--checkbox {
    margin-top: 0 !important;
    .v-messages__wrapper {
      font-family: Roboto;
      font-style: italic;
      font-weight: 300;
      font-size: 11px;
      padding-left: 34px;
      color: rgba(0, 0, 0, 0.59);
    }
    .v-label {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #202124;
    }
  }
}
.result-element {
  @include border(bottom);
  text-align: left;
  min-height: 36px;
  max-height: 36px;
}
.results-list {
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 0px rgba(0, 0, 0, 0.15) !important;
}
.result-text-parcel {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #202124;
}
.result-text-precinct {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.59);
}
</style>
